import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Purchase } from "../../models/purchase.model";
import Shop from "../../models/shop.model";

import { PurchaseService } from "../../services/purchase.service";

@Component({
  selector: "ngx-dialog-print-purchase",
  templateUrl: "dialog-print-purchase.component.html",
  styleUrls: ["dialog-print-purchase.component.scss"],
})
export class DialogPrintPurchaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() purchase?: Purchase;
  @Input() shop?: Shop;
  @Input() rePrint?: boolean = false;
  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";
  menu = "pos"; //a4 , pos
  isRefLanguage = false;
  showDept: boolean = true;
  isDefault: boolean = true;

  constructor(
    protected ref: NbDialogRef<DialogPrintPurchaseComponent>,
    private userService: UserService,
    private purchaseService: PurchaseService
  ) {}

  ngOnInit() {
    this.isDefault =
      this.shop.code !== "vfood" &&
      this.shop.code !== "daian" &&
      this.shop.code !== "ppd"
        ? true
        : false;

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.print();
    }, 1000);
  }

  selectMenu(value) {
    this.menu = value;
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
